import React from 'react'

import { Flex, Text } from 'components/ds'

import { ManageBillingButton } from 'components/common/subscribed-user-billing/manage-billing-button'
import SubscriptionRow from './subscription-row'
import type { CardDetails } from './utils'

type Props = {
  card: CardDetails | null
  billedTo: string[]
  isAdmin: boolean
  hasChargebeeScriptLoaded: boolean
  hasChargebeeScriptFailed: boolean
}

/** Card on file and billing contact, with the CTA to manage them in Chargebee. */
const BillingDetailsRow = ({
  card,
  billedTo,
  isAdmin,
  hasChargebeeScriptLoaded,
  hasChargebeeScriptFailed,
}: Props): React.ReactNode => {
  let cardLabel: string
  if (!card) {
    cardLabel = 'No card on file'
  } else if (card.last4) {
    cardLabel = `${card.brand ?? 'Card'} ending in ${card.last4}`
  } else {
    cardLabel = 'Credit card'
  }

  return (
    <SubscriptionRow
      title="Billing details"
      subtitle={cardLabel}
      aside={
        <ManageBillingButton
          disabled={!isAdmin}
          hasChargebeeScriptLoaded={hasChargebeeScriptLoaded}
          hasChargebeeScriptFailed={hasChargebeeScriptFailed}
        />
      }
    >
      {billedTo.length > 0 && (
        <Flex direction="column">
          <Text size="1" weight="medium" mb="1">
            Billed to:
          </Text>
          {billedTo.map((line, index) => (
            <Text key={index} size="1">
              {line}
            </Text>
          ))}
        </Flex>
      )}
    </SubscriptionRow>
  )
}

export default BillingDetailsRow
